(() => {
  const addSelector = '[data-testid="standalone-add-to-cart"], button[name="add"]';
  const cartBubbleSelector = '[data-testid="cart-drawer-trigger"] [data-testid="cart-bubble"]';

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(addSelector);
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const bubble = document.querySelector(cartBubbleSelector);
    const startingCount = bubble?.textContent?.trim() || '';
    button.dataset.swCartPending = 'true';
    button.setAttribute('aria-busy', 'true');

    let finished = false;
    let timeoutId;
    const observer = new MutationObserver(() => {
      const currentBubble = document.querySelector(cartBubbleSelector);
      const currentCount = currentBubble?.textContent?.trim() || '';
      if (currentCount !== startingCount) clearPending();
    });
    const clearPending = () => {
      if (finished) return;
      finished = true;
      observer.disconnect();
      window.clearTimeout(timeoutId);
      if (button.isConnected) {
        delete button.dataset.swCartPending;
        button.removeAttribute('aria-busy');
      }
    };

    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    timeoutId = window.setTimeout(clearPending, 15000);
  }, true);
})();
